module.exports = __webpack_public_path__ + "img/Product_Tracking.06949aac.svg";